document.addEventListener('DOMContentLoaded', () => {
	// Default Settings
	const defaultSettings = {
			loop: true,
			speed: 700,
			effect: 'fade',
			fadeEffect: { crossFade: true },
			navigation: { nextEl: '.swiper-next', prevEl: '.swiper-prev' },
			autoplay: { delay: 5000, disableOnInteraction: false },
	};

	// Initialize Swiper
	const initializeSwiper = (element, index) => {
			const swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaultSettings;
			element.setAttribute(`data-swiper-${index}`, '');
			return new Swiper(`[data-swiper-${index}]`, swiperConfig);
	};

	// Custom Count
	const CustomCount = (swiper) => {
			if (swiper.passedParams.customcount) {
					const countContainers = document.querySelectorAll(swiper.passedParams.customcount);
					const updateCount = () => {
							countContainers.forEach((container) => {
									container.innerHTML = `0${swiper.realIndex + 1}`;
							});
					};
					updateCount();
					swiper.on('slideChange', updateCount);
			}
	};

	// Custom Control for General Synchronization
	const CustomControls = (swiper, allSwipers) => {
			const getTargetSwipers = (customControl, allSwipers) => {
					if (!customControl) return [];
					const targetIds = customControl.split('#').filter(id => id.trim() !== '');
					return allSwipers.filter(s => targetIds.includes(s.el.id));
			};

			const updateSwiperControls = (swiper, targetSwipers) => {
					if (targetSwipers.length > 0) {
							swiper.controller.control = [...new Set(targetSwipers)];
					}
			};

			const customControl = swiper.passedParams.customcontrol;
			const targetSwipers = getTargetSwipers(customControl, allSwipers);

			updateSwiperControls(swiper, targetSwipers);

			targetSwipers.forEach(targetSwiper => {
					const targetCustomControl = targetSwiper.passedParams.customcontrol;
					if (targetCustomControl) {
							const secondaryTargetSwipers = getTargetSwipers(targetCustomControl, allSwipers);
							const combinedSwipers = [
									swiper,
									...secondaryTargetSwipers,
									...(targetSwiper.controller.control || [])
							];
							updateSwiperControls(targetSwiper, [...new Set(combinedSwipers)]);
					}
			});
	};

	// Custom Control for Columns Synchronization
	const CustomControlsColumns = (allSwipers) => {
    allSwipers.forEach((swiper) => {
        const customControl = swiper.passedParams.customcontrolcolumns;
        if (customControl && !swiper._customControlColumnsInitialized) {
            let mainSwiper = swiper;


            swiper._customControlColumnsInitialized = true;


            const targetSwiperElements = document.querySelectorAll(customControl);
            if (targetSwiperElements.length === 0) {
                console.error(`No elements found for selector: ${customControl}`);
                return;
            }

            const targetSwipers = Array.from(targetSwiperElements).map(targetElement => {
                return allSwipers.find(s => s.el === targetElement);
            }).filter(swiperInstance => swiperInstance); 

            if (targetSwipers.length === 0) {
                console.error(`No Swiper instances found for selector: ${customControl}`);
                return;
            }

            
            mainSwiper.on("slideChange", () => {
                const activeIndex = mainSwiper.realIndex;

                targetSwipers.forEach(targetSwiper => {
                    if (targetSwiper.activeIndex !== activeIndex) {
                        targetSwiper.slideTo(activeIndex);
                    }
                });
            });
        }
    });
};
	// Initialize Swipers
	const allSwipers = [];
	document.querySelectorAll('.swiper-slider').forEach((element, index) => {
			const swiper = initializeSwiper(element, index);
			allSwipers.push(swiper);

			CustomCount(swiper);
			CustomControls(swiper, allSwipers);

			
			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
						if (entry.isIntersecting && swiper.passedParams.autoplay) {
							swiper.autoplay.start();
						} else {
								swiper.autoplay.stop();
						}
				});
		}, {
				threshold: 0.5
		});

		observer.observe(element);
	});


	CustomControlsColumns(allSwipers);

	// Arrow Nav HTML
	const arrowHTML = `
			<span>
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="11.581" height="15.208" viewBox="0 0 11.581 15.208" style="rotate: 180deg">
							<clipPath data-clip>
									<rect width="11.581" height="15.208" transform="translate(0 0)" fill="#b9916c"/>
							</clipPath>
							<g data-name="Group 19" transform="translate(-13)">
									<g data-name="Group 17" transform="translate(13 0)" clip-path="url([data-clip])">
											<path data-name="Path 81" d="M0,14.85V.359A.358.358,0,0,1,.542.052l10.865,6.53a.358.358,0,0,1-.184.664H1.074a.358.358,0,0,0,0,.716H11.223a.358.358,0,0,1,.184.665L.542,15.157A.358.358,0,0,1,0,14.85" transform="translate(0 0)" fill="#b9916c"/>
									</g>
							</g>
					</svg>
			</span>
	`;

	// Add Arrow Navigation to Elements with [data-arrow]
	document.querySelectorAll('[data-arrow]').forEach((arrow) => {
			arrow.innerHTML = arrowHTML;
	});
});